import styled, { css } from 'styled-components';

interface IContainerCollapseProps {
  $hasExpand?: boolean;
  $showBorder?: boolean;
  $maxHeight?: string;
  $overflow?: string;
  $isFlexAccordion?: boolean;
  $changeBorderOnExpand?: boolean;
}

export const ContainerCollapse = styled.div<IContainerCollapseProps>`
  width: 100%;
  overflow: visible;

  ${({ $showBorder }) =>
    $showBorder &&
    css`
      border: 1px solid ${({ theme }) => theme.pantone642C};
      border-radius: 4px;
    `};
  ${({ $hasExpand, theme, $showBorder, $isFlexAccordion, $changeBorderOnExpand }) =>
    $hasExpand &&
    css`
      ${$showBorder && $changeBorderOnExpand && `border-color: ${theme.pantone2190C};`}

      ${$isFlexAccordion &&
      css`
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;

        .MuiCollapse-root,
        .MuiCollapse-wrapper,
        .MuiCollapse-wrapperInner {
          flex: 1 !important;
          display: flex;
          flex-direction: column;
          min-height: 0;
          width: 100%;
        }

        .MuiCollapse-entered {
          height: 100% !important;
        }
      `}
    `};

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      max-height: ${$maxHeight};
    `}
  ${({ $overflow }) =>
    $overflow &&
    css`
      overflow: ${$overflow};
    `}
`;
export const WrapperHeader = styled.div<IContainerCollapseProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0.4rem;
  overflow: auto;
  transition: background 0.3s ease-out;

  ${({ $hasExpand, theme }) =>
    $hasExpand &&
    css`
      border-bottom: 1px solid ${theme.pantone642C};
    `};

  &:hover {
    background: ${({ theme }) => theme.hoverGray};
  }
`;

export const WrapperContent = styled.div<{ $isFlexAccordion?: boolean }>`
  ${({ $isFlexAccordion }) =>
    $isFlexAccordion &&
    css`
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    `}
`;
export const CustomIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
`;
